<script>

import { createNamespacedHelpers } from 'vuex';
// Vuex
import { FETCH_FILE_DATA, GET_FILE_DETAILS } from '@/store/modules/file/action-types';
// Utils
import {
  getFileBlob,
  getFileIconInfo,
  placeholderImg,
  RE_IMAGE_TYPE
} from '@/utils/file';


const { mapActions, mapState } = createNamespacedHelpers('file');

/** Mixin for handling files */
export default {
  data() {
    return {
      fUtilsFetchOnCreated: true,
    };
  },
  computed: {
    /** Array: To be overriden in components. Should return an array of file ids */
    fUtilsFileIds() {
      return [];
    },
    /** Array: Files matching the file ids */
    fUtilsFiles() {
      return (this.fUtilsFileIds || []).map(id => this.fUtilsFileDetailsData[id] || { id });
    },
    /** Boolean: True if at least one of the files is a picture */
    fUtilsContainsPictures() {
      return this.fUtilsFiles.some(file => RE_IMAGE_TYPE.test(file.type));
    },
    /** Number: ID of the first picture file */
    fUtilsFirstId() {
      if (!this.fUtilsContainsPictures) {
        // No images in these files, return placeholder
        return null;
      }
      for (let i = 0, len = this.fUtilsFiles.length; i < len; i++) {
        const file = this.fUtilsFiles[i];
        if (RE_IMAGE_TYPE.test(file.type)) {
          return file.id;
        }
      }
      return null;
    },
    fUtilsFirstPictureData() {
      return this.$store.state.file.fileData[`${this.fUtilsFirstId}`] || placeholderImg;
    },
    /** String: Icon of the type of the first file */
    fUtilsFirstFileIcon() {
      if (this.fUtilsFiles.length) {
        return getFileIconInfo(this.fUtilsFiles[0].type);
      }
      return null;
    },
    ...mapState({
      fUtilsFileDetailsData: state => state.files,
    }),
  },

  watch: {
    fUtilsFileIds() {
      this.GET_FILE_DETAILS({ ids: this.fUtilsFileIds || [] });
    },
    fUtilsFirstId(newVal, oldVal) {
      if (this.fUtilsFirstId && newVal !== oldVal) {
        this.FETCH_FILE_DATA({ fileId: this.fUtilsFirstId });
      }
    },
  },

  created() {
    // FEtch files details
    if (this.fUtilsFetchOnCreated) {
      this.GET_FILE_DETAILS({ ids: this.fUtilsFileIds || [] });
    }

    if (this.fUtilsFirstId) {
      this.FETCH_FILE_DATA({ fileId: this.fUtilsFirstId });
    }
  },

  methods: {
    ...mapActions({
      FETCH_FILE_DATA,
      GET_FILE_DETAILS,
    }),
  },
};
</script>
